<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 18 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="2.5" y="5" width="19" height="14" rx="2" />
    <line x1="2.5" y1="10" x2="21.5" y2="10" />
    <line x1="6.5" y1="14.5" x2="10.5" y2="14.5" />
  </svg>
</template>
